import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { notification, Switch } from "antd";
import { Field } from "formik";

import { Button, Fields } from "components";
import { useGet, useHooks } from "hooks";
import Container from "modules/container";
import { utils } from "services";
import { langlist } from "services/helpers";

const CreateNews = () => {
  const [selectedLang, setSelectedLang] = useState("O'z");
  const navigate = useNavigate();

  const { get, t, params } = useHooks();
  const { id }: any = params;

  const { data: newsData } = useGet({
    name: "news",
    url: `/news/${id}`,
    onSuccess: () => { },
    onError: () => { },
    enabled: !!id,
  });

  const data = get(newsData, "data");
  return (
    <div>
      <Container.Form
        url={data ? `/news/${id}` : "/news"}
        name="news"
        method={data ? "put" : "post"}
        fields={[
          {
            type: "string",
            name: "titleUz",
            value: get(data, "titleUz"),
            required: true,
          },
          {
            type: "string",
            name: "titleRu",
            value: get(data, "titleRu"),
            required: true,
          },
          {
            type: "string",
            name: "titleEn",
            value: get(data, "titleEn"),
            required: true,
          },
          {
            type: "string",
            name: "descriptionUz",
            value: get(data, "descriptionUz"),
            required: true,
          },
          {
            type: "string",
            name: "descriptionRu",
            value: get(data, "descriptionRu"),
            required: true,
          },
          {
            type: "string",
            name: "descriptionEn",
            value: get(data, "descriptionEn"),
            required: true,
          },
          {
            type: "any",
            name: "images",
            value: get(data, "images"),
            required: true
          },
        ]}
        onSuccess={(data, resetForm) => {
          notification.success({
            message: t("Muvaffaqiyatli"),
            duration: 2,
          });
          resetForm();
          navigate("/news");
        }}
        onError={(error) => {
          notification.error({
            message: get(error, "errorMessage", t("Something went wrong!")),
            duration: 2,
          });
        }}
      >
        {({ values, setFieldValue, submitForm }) => {
          return (
            <div className="form-wrapper">
              <div className="w-full">
                <div className="">
                  <div className="flex justify-between mb-[30px]">
                    <div className="content-panel w-full">
                      <p className="content-panel-title mb-[20px]">
                        {t("Yangilik rasmi")}
                      </p>
                      <Field
                        name={`images`}
                        component={Fields.FileUpload}
                        placeholder={t("Rasm joylash")}
                        className="mb-[10px] object-fill"
                        multiple
                        maxFiles="3"
                      />
                    </div>
                  </div>
                  <div className="content-panel m-4 !pb-[80px]">
                    <p className="content-panel-title mb-[20px]">
                      {t("Yangilik tavsifi")}
                    </p>
                    <div className="lang-tabs">
                      {langlist.map((item) => (
                        <div
                          className={
                            selectedLang === item.shortName
                              ? "lang-tabs__tab--selected"
                              : "lang-tabs__tab"
                          }
                          key={get(item, "id")}
                          onClick={() => setSelectedLang(item.shortName)}
                        >
                          <p className="lang-tabs__tab__title">
                            {get(item, "title")}
                          </p>
                        </div>
                      ))}
                      <div className="lang-tabs__last"></div>
                    </div>
                    <div className="w-full">
                      {selectedLang == "O'z" && (
                        <Field
                          type="text"
                          name="titleUz"
                          label={t("Yangilik (uz)")}
                          component={Fields.Input}
                          placeholder={t("Yangilik nomini (uz) kiriting")}
                          required
                        />
                      )}
                      {selectedLang == "Ру" && (
                        <Field
                          type="text"
                          name="titleRu"
                          label={t("Yangilik (ru)")}
                          component={Fields.Input}
                          placeholder={t("Yangilik nomini (ru) kiriting")}
                          required
                        />
                      )}
                      {selectedLang == "En" && (
                        <Field
                          type="text"
                          name="titleEn"
                          label={t("Yangilik (en)")}
                          component={Fields.Input}
                          placeholder={t("Yangilik nomini (en) kiriting")}
                          required
                        />
                      )}
                    </div>
                    <div className="w-full mt-[20px]">
                      {selectedLang == "O'z" && (
                        <Field
                          component={Fields.Ckeditor}
                          rootClassName="h!-[25vh] "
                          type="text"
                          required
                          name="descriptionUz"
                          label={t("Yangilik haqida (uz)")}
                          placeholder={t("Yangilik haqida (uz) kiriting")}
                        />
                      )}
                      {selectedLang == "Ру" && (
                        <Field
                          component={Fields.Ckeditor}
                          rootClassName="h!-[25vh] "
                          required
                          type="text"
                          name="descriptionRu"
                          label={t("Yangilik haqida (ru)")}
                          placeholder={t("Yangilik haqida (ru) kiriting")}
                        />
                      )}
                      {selectedLang == "En" && (
                        <Field
                          component={Fields.Ckeditor}
                          required

                          rootClassName="h!-[25vh] "
                          type="text"
                          name="descriptionEn"
                          label={t("Yangilik haqida (en)")}
                          placeholder={t("Yangilik haqida (en) kiriting")}
                        />
                      )}
                    </div>
                  </div>

                  <Button
                    type="default"
                    title={t("Bekor qilish")}
                    className="w-full mt-[20px] bg-[#fff]"
                    onClick={() => navigate("/news")}
                  />
                  <Button
                    type="primary"
                    className="w-full mt-[20px]"
                    onClick={() => submitForm()}
                    title={
                      get(newsData, "data") ? t("Saqlash") : t("Tasdiqlash")
                    }
                  />

                </div>
              </div>
            </div>
          );
        }}
      </Container.Form>
    </div>
  );
};

export default CreateNews;
